import { Chip } from '@elotech/components';

import { SeveridadeInconsistencia } from '../../type';

const chipHighlightInfo = 'highlight';

const config: Record<
  SeveridadeInconsistencia,
  {
    color: 'negative' | 'warning' | 'neutral';
    className?: string;
    label: string;
  }
> = {
  ERRO: { color: 'negative', label: 'Erro' },
  INCONSISTENCIA: { color: 'warning', label: 'Inconsistência' },
  INFO: { color: 'neutral', className: chipHighlightInfo, label: 'Informação' }
};

export const severidadeCor = (severidade: SeveridadeInconsistencia) =>
  config[severidade].color;

export const severidadeClassName = (severidade: SeveridadeInconsistencia) =>
  config[severidade].className;

export const severidadeOpcoes = (
  Object.keys(config) as SeveridadeInconsistencia[]
).map(value => ({ value, label: config[value].label }));

type Props = {
  severidade: SeveridadeInconsistencia;
};

export const SeveridadeChip = ({ severidade }: Props) => (
  <Chip
    color={config[severidade].color}
    className={config[severidade].className}
    value={config[severidade].label}
  />
);
